import React, { FC, useEffect } from "react";
import { AdContext } from "../context/AdContext";
import { IAds } from "../interfaces/IAds";
declare let adsbygoogle: any;
const AdsComponent: FC<{ data: IAds }> = ({ data }) => {
  const { setting } = React.useContext(AdContext);
  useEffect(() => {
    (adsbygoogle = (window as any).adsbygoogle || []).push({});
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{
        display: "block",
        width: data.display_width ?? "auto",
        height: data.display_height ?? "auto",
      }}
      data-ad-client={setting.ad_client_id}
      data-ad-slot={data.ad_script}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default AdsComponent;
